module.exports = __webpack_public_path__ + "static/fipcbluepanda4-8f2e10d32afd740db45dd5779bbded86.jpeg";